import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import GLCodeFormatErrorCell from 'src/components/custom-cells/GLCodeFormatErrorCell';
import useCheckbookConfiguration from 'src/hooks/useCheckbookConfiguration';
import FormatCell from 'src/sections/checkbook_configuration/FormatCell';

const useCheckbookConfigurationColumns = () => {
  const { t, isPageEditable, areFormatsRequired } = useCheckbookConfiguration();

  const checkbookConfigurationColumns = useMemo(() => {
    const columns: GridColumn<any>[] = [];

    if (isPageEditable) {
      if (areFormatsRequired) {
        columns.push({
          field: 'selected',
          title: '',
          width: '30px',
          menu: false,
        });

        columns.push({
          field: 'errors',
          title: '',
          menu: false,
          component: GLCodeFormatErrorCell,
          width: 40,
        });
      }
    }

    columns.push({
      field: 'format',
      title: t('Acceptable Format(s)'),
      component: FormatCell,
      menu: false,
      sortable: false,
    });

    return columns;
  }, [isPageEditable, areFormatsRequired, t]);
  return { checkbookConfigurationColumns };
};
export default useCheckbookConfigurationColumns;
